import { Form as FormikForm, Formik } from "formik";
import React from 'react';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import FormInput from '../../components/FormInput';
import { validationSchema } from '../../validations/financialyears.validation';
import { Button } from "react-bootstrap";
import Toggle from '../../components/Toggle';
import { handleAddFinancialYear } from "../../services/financialyear.service";
import toast from 'react-hot-toast';
import { useNavigate } from "react-router-dom";


const FinancialYearModal = ({ modal, toggle }) => {
    const navigate = useNavigate();
    
    const onSubmit = async (values) => {
        handleAddFinancialYear(values).then(response => {
            toast.success(response.data.message);
            navigate("/financial-years");
        }).catch((error) => {
            toast.error(error.response.data.detail);
        });
    };

    return (
        <Modal className="financial-year-modal-cover" isOpen={modal} toggle={toggle} centered>
            <ModalHeader className='border-0 fs-16 fw-semibold' toggle={toggle}>Add Financial Year</ModalHeader>
            <ModalBody>
                <Formik
                    initialValues={{
                        financialYearName: "",
                        status: true,
                    }}
                    validationSchema={validationSchema}
                    onSubmit={onSubmit}
                >
                    {({
                        errors,
                        handleBlur,
                        handleChange,
                        handleSubmit,
                        isSubmitting,
                        touched,
                        values,
                    }) => (
                        <FormikForm>
                            <FormInput
                                error={errors.financialYearName}
                                id="financialYearName"
                                key={"financialYearName"}
                                label="Financial Year Name"
                                name="financialYearName"
                                onBlur={handleBlur}
                                onChange={handleChange}
                                placeholder="Enter financial year name"
                                touched={touched.financialYearName}
                                type="text"
                                value={values.financialYearName || ""}
                            />

                            <Toggle
                                id="status"
                                key={"status"}
                                label="Status"
                                name="status"
                                onChange={handleChange}
                                value={values.status}
                            />
                        </FormikForm>
                    )}
                </Formik>
            </ModalBody>
            <ModalFooter className='border-0'>
                <Button className="fs-14 fw-semibold" variant="outline-dark" onClick={toggle}>
                    Cancel
                </Button>{' '}
                <Button className="fs-14 fw-semibold" variant="primary" onClick={onSubmit}>
                    Add
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default FinancialYearModal;
